import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";
import desingReducer from "./desingReducer";
import HomeSaga from "./saga";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: desingReducer,
  middleware: [sagaMiddleware],
  // middleware: [...getDefaultMiddleware(), sagaMiddleware],
});
sagaMiddleware.run(HomeSaga);
